import { AlertProps } from "@alm/flow-ds/components";
import {
	businessLogicPropertyType,
	BusinessLogicUpdateData,
	FormBusinessLogicUpdateDataValidation,
} from "hooks/FormDesigner/useElementList";
import { businessLogicValue } from "schemas/elements";
import BusinessLogicList from "../BusinessLogicList";

type Props = {
	value: businessLogicValue;
	root: boolean;
	elementIndex: number;
	updateStore: (
		data: BusinessLogicUpdateData<businessLogicPropertyType>
	) => Promise<void>;
	required: boolean;
	id: string;
	validation: boolean;
	updateFormBusinessLogicValidation: (
		data: FormBusinessLogicUpdateDataValidation
	) => void;
	addAlert: (alert: string, status: AlertProps["status"]) => void;
	desc: string;
};

export default ({ ...rest }: Props) => {
	return <BusinessLogicList actions={["afterPatch"]} {...rest} />;
};
